<template>
  <section class="json-editor">
    <div class="row mt-1">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <textarea
          v-validate="{ validJson: true }"
          :class="{
            'is-invalid': errors.has('initRequestTextArea'),
            'light-grey': dataEdited,
          }"
          v-model="jsonDataStringfy"
          :rows="rowCount"
          :disabled="isDisabled"
          class="form-control"
          name="initRequestTextArea"
          spellcheck="false"
          @input="onDataUpdate"
        />
        <span
          v-if="errors.has('initRequestTextArea')"
          class="invalid-feedback">{{
            errors.first("initRequestTextArea")
          }}</span>
      </div>
    </div>
  </section>
</template>
<style lang="sass" scoped>
@import "json-editor"
</style>

<script>
import '../../../utils/custome-validator'
import utils from '../../../utils/utils'

export default {
  name: 'JsonEditor',
  props: {
    jsonData: Object,
    isEdited: Boolean,
    rowCount: Number,
    enableEditing: {
      default: true,
      type: Boolean
    }
  },

  data () {
    return {
      jsonDataStringfy: JSON.stringify(this.jsonData, undefined, 4)
    }
  },

  computed: {
    dataEdited: function () {
      return this.isEdited
    },
    isDisabled: function () {
      return this.enableEditing
    }
  },
  watch: {
    jsonData: {
      handler () {
        this.jsonDataStringfy = JSON.stringify(this.jsonData, undefined, 4)
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    onDataUpdate () {
      if (utils.isJsonString(this.jsonDataStringfy)) {
        let updatedJsonData = JSON.parse(this.jsonDataStringfy)
        this.$emit('jsonDataUpdated', updatedJsonData)
      }
    }
  }
}
</script>
